<template>
  <div id="app">
    <Header/>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="200">
                <router-view/>
            </fade-transition>
        </main>
        <Footer/>
  </div>
</template>

<script>
import Header from "./layout/AppHeader";
import Footer from "./layout/AppFooter";
import { FadeTransition } from "vue2-transitions";

export default {
  name: 'app',
  components: {
    Footer,
    Header,
    FadeTransition
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 10px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
